module.exports = __webpack_public_path__ + "static/media/img-600x400-1.916f988c.jpg";